export default {
    props: {
        layerDefaultsMarkerShape: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.shape'
        }, 
        layerDefaultsMarkerTooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.autoHide'
        }, 
        layerDefaultsMarkerTooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.close.effects'
        }, 
        layerDefaultsMarkerTooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.close.duration'
        }, 
        layerDefaultsMarkerTooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.open.effects'
        }, 
        layerDefaultsMarkerTooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.open.duration'
        }, 
        layerDefaultsMarkerTooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.content'
        }, 
        layerDefaultsMarkerTooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.content.url'
        }, 
        layerDefaultsMarkerTooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.template'
        }, 
        layerDefaultsMarkerTooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.callout'
        }, 
        layerDefaultsMarkerTooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.iframe'
        }, 
        layerDefaultsMarkerTooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.height'
        }, 
        layerDefaultsMarkerTooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.width'
        }, 
        layerDefaultsMarkerTooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.position'
        }, 
        layerDefaultsMarkerTooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.showAfter'
        }, 
        layerDefaultsMarkerTooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.showOn'
        }, 
        layerDefaultsMarkerOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.opacity'
        }, 
        layerDefaultsShapeAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.attribution'
        }, 
        layerDefaultsShapeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.opacity'
        }, 
        layerDefaultsShapeStyleFillColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.fill.color'
        }, 
        layerDefaultsShapeStyleFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.fill.opacity'
        }, 
        layerDefaultsShapeStyleStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.color'
        }, 
        layerDefaultsShapeStyleStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.dashType'
        }, 
        layerDefaultsShapeStyleStrokeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.opacity'
        }, 
        layerDefaultsShapeStyleStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.width'
        }, 
        layerDefaultsBubbleAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.attribution'
        }, 
        layerDefaultsBubbleOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.opacity'
        }, 
        layerDefaultsBubbleMaxSize: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.maxSize'
        }, 
        layerDefaultsBubbleMinSize: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.minSize'
        }, 
        layerDefaultsBubbleStyleFillColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.fill.color'
        }, 
        layerDefaultsBubbleStyleFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.fill.opacity'
        }, 
        layerDefaultsBubbleStyleStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.color'
        }, 
        layerDefaultsBubbleStyleStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.dashType'
        }, 
        layerDefaultsBubbleStyleStrokeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.opacity'
        }, 
        layerDefaultsBubbleStyleStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.width'
        }, 
        layerDefaultsBubbleSymbol: {
            type: [String, Function],
            default: undefined,
            kComposite: 'layerDefaults.bubble.symbol'
        }, 
        layerDefaultsTileSize: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.tileSize'
        }, 
        layerDefaultsTileUrlTemplate: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.tile.urlTemplate'
        }, 
        layerDefaultsTileAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.tile.attribution'
        }, 
        layerDefaultsTileSubdomains: {
            type: Array,
            default: undefined,
            kComposite: 'layerDefaults.tile.subdomains'
        }, 
        layerDefaultsTileOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.tile.opacity'
        }, 
        layerDefaultsBingAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.attribution'
        }, 
        layerDefaultsBingOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bing.opacity'
        }, 
        layerDefaultsBingKey: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.key'
        }, 
        layerDefaultsBingImagerySet: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.imagerySet'
        }, 
        layerDefaultsBingCulture: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.culture'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMap/LayerDefaults.js